import { defineComponent } from '@vue/composition-api'

import QBadge from 'quasar/src/components/badge/QBadge.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QList from 'quasar/src/components/item/QList.js';import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import '@/styles/shared/AppMenu.sass'

export default defineComponent({
  name: 'AppMenu',

  props: {
    items: {},
    dark: {
      type: Boolean,
      default: true
    }
  },

  inject: ['User'],

  watch: {
    $page(page) {
      this.showMenu(this.$refs[page.url])
    }
  },

  computed: {
    isLoading() {
      return this.User.isLoading.value
    }
  },

  methods: {
    showMenu(comp) {
      if (comp !== void 0 && comp !== this) {
        this.showMenu(comp.$parent)
        comp.show !== void 0 && comp.show()
      }
    },

    getDrawerMenu(h, menu, path, level) {
      if (menu == void 0) {
        if (this.isLoading) {
          return h(QItem, {
            props: {
              dark: this.dark
            }
          }, [
            h(QItemSection, {
              props: { avatar: true }
            }, [
              h(QSkeleton, { props: { dark: this.dark, type: 'QAvatar', size: '2em' } })
            ]),

            h(QItemSection, [
              h(QItemLabel, [
                h(QSkeleton, { props: { dark: this.dark, type: 'text', width: '60%', height: '2em' } })
              ])
            ])
          ])
        } else {
          return null
        }
      }

      if (menu.children !== void 0) {
        return h(
          QExpansionItem,
          {
            staticClass: 'non-selectable',
            class: this.dark ? 'q-expansion-item--dark' : '',
            ref: path,
            key: `${menu.name}-${path}`,
            props: {
              group: 'sidebar',
              label: menu.name,
              dense: level > 0,
              icon: menu.icon,
              defaultOpened: menu.opened,
              expandSeparator: false,
              switchToggleSide: level > 0,
              denseToggle: level > 0,
              dark: this.dark
            }
          },
          menu.children.map(item => this.getDrawerMenu(
            h,
            item,
            item?.path !== void 0 ? item.path : '',
            level + 1
          ))
        )
      }

      const props = {
        to: path,
        dark: this.dark,
        dense: level > 0,
        insetLevel: level > 1 ? 1.2 : level,
        exact: menu.exact,
        activeRegex: menu.regex
      }

      const attrs = {}

      if (menu.external === true) {
        Object.assign(props, {
          to: void 0,
          clickable: true,
          tag: 'a'
        })

        attrs.href = menu.path
        attrs.target = '_blank'
      }

      return h(QItem, {
        ref: path,
        key: path,
        props,
        attrs,
        staticClass: 'app-menu-entry non-selectable'
      }, [
        menu.icon !== void 0
          ? h(QItemSection, {
            props: { avatar: true }
          }, [h(QIcon, { props: { name: menu.icon, size: 'sm' } })])
          : null,

        h(QItemSection, [menu.name]),

        menu.badge !== void 0
          ? h(QItemSection, {
            props: { side: true }
          }, [h(QBadge, {
            style: 'margin: 0 10px',
            props: {
              color: 'orange-9'
            }
          }, [menu.badge])])
          : null
      ])
    }
  },

  render(h) {
    return h(QList, { staticClass: 'app-menu' }, this.items.map(
      item => this.getDrawerMenu(h, item, item?.path, 0)
    ))
  },

  mounted() {
    this.showMenu(this.$refs[this.$page.url])
  }
})
